import React from "react";
import {
  faMinus,
  faPlus,
  faAngleRight,
  faAngleLeft,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import GraphButton from "./GraphButton";
import ZoomService from "../../services/zoomService/zoom.service";
import PositionSearch from "../PositionSearch";

function Header({
  zoomService,
  children,
  genomeId,
  isExpanded,
  toggleExpanded,
  themeCl,
}) {
  const scrollRight = () => zoomService.buttonPan(false);
  const scrollLeft = () => zoomService.buttonPan(true);
  const zoomIn = () => zoomService.buttonZoom(true);
  const zoomOut = () => zoomService.buttonZoom(false);

  return (
    <div className="tw-flex tw-w-full">
      <div className="tw-flex-grow">
        <div className="tw-p-2 tw-flex tw-text-xs tw-items-center tw-flex-wrap tw-w-full">
          <div className="tw-font-bold tw-flex-grow tw-relative tw-h-6">
            <div className="tw-absolute tw-inset-0">
              <div className="color-1 tw-opacity-80 tw-w-full tw-trucate tw-whitespace-no-wrap">
                <span data-tooltip-class="genome-browser-small-tooltip">
                  {children}
                </span>
              </div>
              <div className="tw-text-3xs tw-font-bold tw-text-sky-500 tw-truncate">
                <span
                  data-tooltip={genomeId}
                  data-tooltip-class="genome-browser-small-tooltip"
                >
                  {genomeId}
                </span>
              </div>
            </div>
          </div>

          <PositionSearch themeCl={themeCl} zoomService={zoomService} />

          <div className="tw-w-2" />

          <div className="tw-border border-2 tw-rounded-lg tw-flex">
            <GraphButton title="Zoom Out" onClick={zoomOut}>
              <FontAwesomeIcon icon={faMinus} />
            </GraphButton>
            <div className="tw-border-l border-1" />
            <GraphButton title="Zoom In" onClick={zoomIn}>
              <FontAwesomeIcon icon={faPlus} />
            </GraphButton>
          </div>

          <div className="tw-w-2" />

          <div className="tw-border border-2 tw-rounded-lg tw-flex">
            <GraphButton title="Pan Left" onClick={scrollLeft}>
              <FontAwesomeIcon icon={faAngleLeft} />
            </GraphButton>
            <div className="tw-border-l border-1" />

            <GraphButton title="Pan Right" onClick={scrollRight}>
              <FontAwesomeIcon icon={faAngleRight} />
            </GraphButton>
          </div>
        </div>
      </div>
      <div className="tw-w-16 tw-flex-shrink-0 tw-text-center tw-pt-2 tw-border-l border-1 ">
        <GraphButton
          title={isExpanded ? "Exit Fullscreen" : "Enter Fullscreen"}
          onClick={() => toggleExpanded(!isExpanded)}
        >
          <div className="tw-w-6 tw-h-6 tw-text-lg tw-rounded-lg tw-flex tw-items-center tw-justify-center">
            <i className={isExpanded ? "fa fa-compress" : "fa fa-expand"} />
          </div>
        </GraphButton>
      </div>
    </div>
  );
}

Header.propTypes = {
  zoomService: PropTypes.instanceOf(ZoomService).isRequired,
  children: PropTypes.node.isRequired,
  genomeId: PropTypes.string.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  toggleExpanded: PropTypes.func.isRequired,
  themeCl: PropTypes.string.isRequired,
};

export default React.memo(Header);
